import { ApiEndpoints } from "../core";
import { httpClient } from "../core";
import {
  changeLoadingState,
  dispatch,
  setAdminLogin,
  setAdminLogout,
  setAdminProfile,
  setErrorMessage,
  setSuccessMessage,
} from "../redux";

export const adminLoginService = async (username, password) => {
  try {
    dispatch(changeLoadingState(true));
    const resp = await httpClient().patch(ApiEndpoints.adminLogin, {
      username,
      password,
    });

    if (!resp.data.success && resp.status >= 201) {
      throw new Error(resp.data.message);
    }

    dispatch(setAdminLogin(resp.data.result.token));
    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    dispatch(changeLoadingState(false));
    dispatch(setErrorMessage(error.message));
  }
};

export const forgetAdminPasswordService = async (username) => {
  try {
    // API Fetching
    const resp = await httpClient().patch(ApiEndpoints.forgetAdminPassword, {
      username,
    });
    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeLoadingState(false));
  }
};

export const resetAdminPasswordService = async (
  // token,
  currentPassword,
  newPassword
) => {
  try {
    // API Fetching
    const resp = await httpClient().patch(ApiEndpoints.resetAdminPassword, {
      // token,
      currentPassword,
      newPassword,
    });
    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeLoadingState(false));
  }
};

export const getAdminProfile = async () => {
  try {
    // Set Loading
    dispatch(changeLoadingState(true));

    // API Fetching
    const resp = await httpClient().get(ApiEndpoints.adminProfile);

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(setAdminProfile(resp.data.results));
    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeLoadingState(false));
  }
};

/**
 * To delete the admin permanently
 */
export const logoutAdmin = async () => {
  try {
    // Set Loading
    dispatch(changeLoadingState(true));

    // Update to Store
    dispatch(setAdminLogout());
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeLoadingState(false));
  }
};
